export default __webpack_public_path__ + "static/Slide3-cde152dd51a6d61741977558d123a043.png";